module.exports = __webpack_public_path__ + "static/media/red-moon-desert.41c4c9a6.jpg";